/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "a",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "b",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "c",
                type: "uint256",
            },
        ],
        name: "getGasCostOfMulDivCeil",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "a",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "b",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "c",
                type: "uint256",
            },
        ],
        name: "getGasCostOfMulDivFloor",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "a",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "b",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "c",
                type: "uint256",
            },
        ],
        name: "getMulDivCeil",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "a",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "b",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "c",
                type: "uint256",
            },
        ],
        name: "getMulDivFloor",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b506102aa806100206000396000f3fe608060405234801561001057600080fd5b506004361061004c5760003560e01c8063288ea0e71461005157806368eb05771461007657806397e974f414610089578063dc2868321461009c575b600080fd5b61006461005f366004610201565b6100af565b60405190815260200160405180910390f35b610064610084366004610201565b6100c6565b610064610097366004610201565b6100ec565b6100646100aa366004610201565b6100f9565b60006100bc848484610106565b90505b9392505050565b6000805a90506100d7858585610154565b505a6100e3908261022c565b95945050505050565b60006100bc848484610154565b6000805a90506100d78585855b6000610113848484610154565b90506000828061013357634e487b7160e01b600052601260045260246000fd5b84860911156100bf57600019811061014a57600080fd5b806100e381610243565b60008080600019858709858702925082811083820303915050806000141561018e576000841161018357600080fd5b5082900490506100bf565b80841161019a57600080fd5b6000848688096001861981018716968790046003810260029081188083028203028083028203028083028203028083028203028083028203029182029003026000889003889004909101858311909403939093029303949094049190911702949350505050565b600080600060608486031215610215578283fd5b505081359360208301359350604090920135919050565b60008282101561023e5761023e61025e565b500390565b60006000198214156102575761025761025e565b5060010190565b634e487b7160e01b600052601160045260246000fdfea26469706673582212200b4210656370848c2d99f26a13ac3db22ee2cfbfe3524fbe18fd97095b1c612b64736f6c63430008040033";
const isSuperArgs = (xs) => xs.length > 1;
export class TestMulDivMath__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
TestMulDivMath__factory.bytecode = _bytecode;
TestMulDivMath__factory.abi = _abi;
